<template>
  <div id="register" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }" class="pt-4 pb-8 lg:py-6 xl:py-8 px-2 lg:px-8 max-w-6xl mx-auto text-NotoSansRegular">

    <form action="javascript:void(0);" class="text-NotoSansRegular textColorBlack mx-auto max-w-3xl">
      <h5 class="text-center tracking-wider text-xl mb-2">
        會員註冊
      </h5>
      <div class="w-full bg-white rounded py-2 lg:p-4 flex flex-col justify-between leading-normal">
        <div class="flex flex-wrap textColorBlack">
          <!-- 姓名 -->
          <div class="w-full px-3 mb-2 md:mb-4 md:flex">
            <label class="md:flex items-center text-sm md:text-sm md:w-1/5 tracking-wide" for="name">
              會員姓名
            </label>
            <input class="md:w-3/5 appearance-none border-gray-500 focus:border-gray-900 block w-full  text-sm border rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
              id="name" type="text" @blur="checkField('userName')" placeholder="請輸入姓名" v-model.trim="registerUser.name" :class="{ borderRed: validation.name === false }" maxlength="15" :disabled="$route.query.name">
          </div>

          <!-- 信箱 -->
          <div class="w-full px-3 mb-2 md:mb-4 md:flex">
            <label class="md:pt-2 md:text-sm md:w-1/5 tracking-wide text-sm mb-2" for="email">
              E-Mail
            </label>
            <div class="w-full md:w-3/5">
              <input class="w-full appearance-none block text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900" spellcheck="false"
                id="email" type="email" placeholder="" v-model.trim="registerUser.email" autocomplete="email"
                :class="{ borderRed: validation.email === false && !$route.query.email }" @change="checkField('userMail')"  @blur="checkField('userMail')" :disabled="$route.query.email">
                <p class="text-xs textColorRed tracking-wider">※注意事項</p>
                <p class="text-xs tracking-wider" v-if="!$route.query.email || !$route.query.name">
                  。使用hotmail有可能收不到驗證信，建議使用gmail信箱
                </p>
                <p class="text-xs tracking-wider" v-if="!$route.query.email || !$route.query.name">
                  。一直沒收到驗證信，有可能跑到垃圾信件或被擋信了喔
                </p>
                <p class="text-xs tracking-wider" v-if="$route.query.email && $route.query.name">
                  使用Google帳號建立LiveABC會員，設定完成後即可使用Google帳號快速登入！
                </p>
            </div>
            <div class="w-full md:w-1/5 md:px-1" v-if="!$route.query.email || !$route.query.name">
              <button class="focus:outline-none text-sm button-code py-3 px-3 rounded text-white block whitespace-no-wrap w-full" :class="{ disabledBtn: !this.canClick }"
                @click="verifyEmail()" ref="verifyEmail" :disabled="status.isCheckingAccount">
                {{ content }}
                <font-awesome-icon icon="circle-notch" spin v-if="status.isCheckingAccount" />
              </button>
              <div class="textColorRed text-xs text-right md:text-left" v-if="validation.emailRex === false">E-mail格式錯誤，請重新填寫</div>
            </div>
          </div>

          <!-- 驗證碼 -->
          <div class="w-full px-3 mb-2 md:mb-4 flex flex-wrap" v-if="!$route.query.email || !$route.query.name">
            <label class="md:pt-2 text-sm w-full md:w-1/5 tracking-wide mb-2" for="verity">
              E-Mail驗證碼
            </label>
            <div class="w-full md:w-3/5">
              <input class="w-full appearance-none block text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900" spellcheck="false"
                id="verity" type="text" autocomplete="off" placeholder="請輸入六位驗證碼"
                :class="{ borderRed: validation.isCode === false }" @change="checkField('code')"  @blur="checkField('code')" v-model.trim="code" maxlength="6"
                >
                <div class="textColorRed text-xs md:pl-2 text-right md:text-left">{{ codeText }}</div>
            </div>
            <div class="w-full md:w-1/5 md:px-1">
            </div>
          </div>

          <!-- 手機 -->
          <div class="w-full px-3 mb-2 md:mb-4 md:flex">
            <label class="md:pt-2 md:text-sm md:w-1/5 tracking-wide text-sm mb-2" for="mobile">
              手機
            </label>
            <div class="w-full md:w-3/5 flex">
              <div class="w-1/3 relative pr-1">
                <select @change="checkField('mobile')" v-model="registerUser.country_code" class="block appearance-none w-full text-sm border border-gray-500 py-3 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-900" id="country_code">
                  <option :value="item.phoneCode" v-for="(item, index) in countryJson" :key="index">{{ item.countryName }}({{ item.phoneCode }})</option>
                </select>
                <div class=" pointer-events-none absolute inset-y-0 right-0 flex items-center px-1 md:px-2">
                  <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
              <div class="flex-1">
                <input class="w-full appearance-none block text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900" spellcheck="false"
                  id="mobile" type="text" placeholder="0900123456" v-model.trim="registerUser.mobile" autocomplete="mobile"
                  :class="{ borderRed: validation.mobile === false || registerUser.mobile && validation.mobileRex === false }" @change="checkField('mobile')" @blur="checkField('mobile')">
                <div class="textColorRed text-xs text-right md:text-left" v-if="validation.mobileRex === false">手機格式錯誤，請重新填寫</div>
              </div>
            </div>
          </div>

          <!-- 密碼 -->
          <div class="w-full px-3 mb-2 md:mb-4 md:flex">
            <label class="md:pt-2 md:text-sm md:w-1/5 tracking-wide text-sm" for="password">
              輸入密碼
            </label>
            <input class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-900"
              id="password" type="password" @change="checkField('password')" @blur="checkField('password')" placeholder="請輸入8碼至15碼英數字" v-model.trim="registerUser.pwd"
              :class="{ borderRed: validation.pwd === false }" autocomplete="new-password" maxlength="15" name="firstShoppingPwd">
          </div>
          <div class="w-full px-3 mb-2 md:mb-4 md:flex -mt-2 md:-mt-4" v-if="validation.pwdRex === false">
            <div class="md:w-1/5"></div>
            <div class="md:w-3/5 textColorRed text-right text-xs">請輸入8碼至15碼英數字</div>
          </div>
          <div class="w-full px-3 mb-2 md:mb-4 md:flex">
            <label class="md:pt-2 md:text-sm md:w-1/5 tracking-wide text-sm" for="password_check">
              確認密碼
            </label>
            <input class="md:w-3/5 appearance-none block w-full  text-sm border border-gray-500 rounded py-3 px-4 eading-tight focus:outline-none focus:bg-white focus:border-gray-900"
              id="password_check" type="password" @change="checkField('passwordCheck')" @blur="checkField('passwordCheck')" placeholder="再次輸入密碼" v-model.trim="registerUser.pwdCheck"
              :class="{ borderRed: validation.pwdCheck === false }" autocomplete="off" maxlength="15">
          </div>
          <div class="w-full px-3 mb-2 md:mb-4 md:flex -mt-2 md:-mt-4" v-if="validation.pwdEqal === false">
            <div class="md:w-1/5"></div>
            <div class="md:w-3/5 textColorRed text-right text-xs">密碼不一致</div>
          </div>

        </div>
      </div>
      <div class="mb-4 px-4 lg:px-6 pb-4 lg:pb-6 flex">
        <div class="w-1/5 hidden md:block"></div>
        <div class="w-full md:w-4/5">
          <!-- 接收優惠 -->
          <div class="items-center flex pb-1">
            <div class="controls-item">
              <input id="get-mail" name="subscribe" type="checkbox" class="checkbox hidden" v-model="isAgreeReceiveDM" :class="{ labelisTrue: isAgreeReceiveDM }">
              <label for="get-mail">
                <span class="text-sm ml-2">我同意接收優惠訊息</span>
              </label>
            </div>
          </div>
          <!-- 同意條款 -->
          <div class="items-center flex pb-1">
            <div class="controls-item">
              <input :class="{ labelisTrue: isAgreePolicy }" id="agreePolicy" name="agreePolicy"
                type="checkbox" class="checkbox hidden" v-model="isAgreePolicy">
              <label for="agreePolicy">
                <span class="text-sm w-full ml-2">
                  我同意接受LiveABC
                  <router-link :to="{ name: 'policy' }" class="underline">服務條款</router-link>
                  與
                  <router-link :to="{ name: 'privacy' }" class="underline">隱私權政策</router-link>
                </span>
              </label>
            </div>
          </div>
          <div class="flex my-3 justify-start w-full">
            <button class="button-red py-3 px-16 rounded text-white w-full md:w-auto text-sm cursor-pointer" @click.prevent="registerCheck">
              會員註冊
              <font-awesome-icon icon="circle-notch" spin v-if="status.isRegister" />
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import Regex from '@/components/modules/regex'
import moment from 'moment'
import ga4 from '@/components/modules/ga4'
import countryJson from '@/components/modules/countryCode.json'
export default {
  name: 'Register',
  metaInfo () {
    return {
      title: '會員註冊',
      titleTemplate: null
    }
  },
  data () {
    return {
      countryJson: countryJson,
      status: {
        isRegister: false,
        isCheckingAccount: false,
        isCoundown: false
      },
      // 驗證碼
      code: null,
      codeText: '',

      content: '發送驗證碼',
      totalTime: 300,
      canClick: true,

      // 驗證
      validation: {
        name: null,
        email: null,
        pwd: null,
        pwdCheck: null,
        pwdEqal: null,
        pwdRex: null,
        emailRex: null,
        isCode: null,
        mobile: null,
        mobileRex: null
      },

      // 會員資料
      registerUser: {
        name: null,
        email: null,
        country_code: '+886',
        mobile: null,
        pwd: null,
        pwdCheck: null
      },

      // 同意隱私權/服務條款
      isAgreePolicy: false,
      // 接收優惠
      isAgreeReceiveDM: true
    }
  },
  components: {
  },
  mixins: [
    Regex,
    ga4
  ],
  computed: {
    ...mapGetters([
      'authorized'
    ]),
    checkContract () {
      return Object.values(this.validation).every(Boolean)
    }
  },
  mounted () {
    if (this.$route.query.email && this.$route.query.name) {
      this.registerUser.email = this.$route.query.email
      this.registerUser.name = this.$route.query.name
      this.validation.isCode = true
    }
  },
  updated () {
  },
  methods: {
    ...mapActions({
      doRegister: 'register'
    }),

    checkField (field) {
      const { name, email, pwd, pwdCheck, mobile, country_code } = this.registerUser

      const validations = {
        userName: () => {
          this.validation.name = !!name
        },
        userMail: () => {
          this.validation.email = !!email
          this.validation.emailRex = this.rexEmail(email)
        },
        mobile: () => {
          this.validation.mobile = !!mobile
          this.validation.mobileRex = mobile && country_code === '+886'
            ? this.rexMobile(mobile)
            : true
        },
        password: () => {
          this.validation.pwd = !!pwd
          this.validation.pwdRex = this.rexPassword(pwd)
        },
        passwordCheck: () => {
          this.validation.pwdCheck = !!pwdCheck
          this.validation.pwdEqal = this.checkPwdEqual(pwd, pwdCheck)
        },
        code: () => {
          if ((this.$route.query.email && this.$route.query.name) || (this.code && this.code.length === 6)) {
            this.validation.isCode = true
          } else {
            this.validation.isCode = false
          }
        }
      }

      if (field && validations[field]) {
        validations[field]()
      } else {
        Object.values(validations).forEach(fn => fn())
      }
    },

    async registerCheck () {
      console.log(this.validation)
      await this.checkField()
      if (this.checkContract && this.isAgreePolicy) {
        this.status.isRegister = true
        this.registerAction()
      } else {
        this.status.isRegister = false
        if (!this.isAgreePolicy) {
          this.$swal({
            icon: 'info',
            title: '請勾選同意接受LiveABC「服務條款」與「隱私權政策」才算完成會員註冊喔！',
            showCancelButton: false,
            confirmButtonText: `OK`,
            customClass: {
              container: 'text-sm text-base',
              popup: 'text-base',
              title: 'text-xl',
              confirmButton: 'comfirmBtn px-6 py-3',
              cancelButton: 'comfirmBtn px-6 py-3',
              footer: 'text-sm textColorDarkBlack'
            }
          })
        }
      }
    },

    async registerAction () {
      let formData = {
        account: this.registerUser.email,
        password: this.registerUser.pwd,
        name: this.registerUser.name,
        country_code: this.registerUser.country_code,
        mobile: this.registerUser.mobile,
        code: this.code,
        isAgreeReceiveDM: this.isAgreeReceiveDM
      }

      await this.doRegister(formData)
      this.status.isRegister = false

      // ga4
      if (this.authorized) {
        this.sign_up_track()
      }
    },

    async verifyEmail () {
      if (this.rexEmail(this.registerUser.email) && this.registerUser.email && !this.status.isCoundown) {
        let url = `/account/verify?account=${this.registerUser.email}`
        this.status.isCheckingAccount = true

        await axios.get(url)
          .then((response) => {
            if ((response.data.result === true && response.data.message === 'verification code sent.') || (response.data.result === false && response.data.message === 'Verification code not expired.')) {
              this.countDown()
              this.codeText = '系統已發送驗證碼，請前往信箱查看'
            } else {
              this.alreadyMember()
            }
            this.status.isCheckingAccount = false
          })
          .catch(() => {
            this.status.isCheckingAccount = false
          })
      }
    },

    alreadyMember () {
      this.$swal({
        icon: 'info',
        title: '此Email已註冊過囉!',
        text: '請使用原帳號登入或更新Email',
        showCancelButton: true,
        confirmButtonText: `登入`,
        cancelButtonText: '關閉',
        customClass: {
          container: 'text-sm text-base',
          popup: 'text-base',
          title: 'textColorRed text-lg',
          confirmButton: 'comfirmBtn px-6 py-3',
          cancelButton: 'comfirmBtn px-6 py-3',
          footer: 'text-sm textColorDarkBlack'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push({ name: 'login' })
        }
      })
    },

    countDown () {
      if (!this.canClick) return
      this.canClick = false

      let durationValue = moment.duration(this.totalTime, 'seconds')
      let hours = Math.floor(durationValue.asHours())
      let mins = Math.floor(durationValue.asMinutes()) - hours * 60
      let secs = Math.floor(durationValue.asSeconds()) - mins * 60
      let sesShow
      if (secs === 0) {
        sesShow = '00'
      } else if (secs < 10) {
        sesShow = '0' + secs
      } else {
        sesShow = secs
      }

      this.content = '剩餘 ' + mins + ':' + sesShow
      this.status.isCoundown = true
      let clock = window.setInterval(() => {
        this.totalTime--

        let durationValue = moment.duration(this.totalTime, 'seconds')
        let hours = Math.floor(durationValue.asHours())
        let mins = Math.floor(durationValue.asMinutes()) - hours * 60
        let secs = Math.floor(durationValue.asSeconds()) - mins * 60
        let sesShow
        if (secs === 0) {
          sesShow = '00'
        } else if (secs < 10) {
          sesShow = '0' + secs
        } else {
          sesShow = secs
        }

        this.content = '剩餘 ' + mins + ':' + sesShow
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = '重新傳送驗證碼'
          this.totalTime = 300
          this.canClick = true
          this.status.isCoundown = false
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  #register {
    -webkit-text-size-adjust: none;
    -moz-text-size-adjust: none;
    -ms-text-size-adjust: none;
    text-size-adjust: none;

    input, textarea {
      font-size: initial;
    }
    .button-code {
      background: #2F80ED;
      transition: .3s;
      &:hover {
        background: #1D4ED8;
      }
    }
    .comfirmBtn {
      display: inline-block;
      font-size: 14px !important;
      text-align: center;
      text-decoration: none;
      vertical-align: middle;
      height: auto;
      line-height: 1;
      background-color: #fff  !important;
      border: 1px solid #9c9c9c  !important;
      color: #434343 !important;
      white-space: nowrap;
      transition: .3s !important;
      border-radius: 5px;
      &:hover {
        background-color: #434343 !important;
        color: #fff !important;
      }
    }
    .disabledBtn {
      background-color: gray !important;
      color:#ffffff;
      cursor: not-allowed;
      &:hover {
        background-color: gray !important;
        color:#ffffff;
        cursor: not-allowed;
      }
    }
    .disabled {
      cursor: not-allowed !important;
    }
    .disabledRegister {
      cursor: default !important;
      background: gray;
      color: white;
      &:hover {
        background: gray !important;
        color: white !important;
      }
    }
    .controls-item {
      input[type="checkbox"] {
        box-sizing: border-box;
        padding: 0;
        margin-right: .4em;
        width: 100%;
        margin-bottom: 10px;
        &:hover + label:before {
          background: #e6e6e6;
        }
      }
      label {
        position: relative;
        display: inline-block;
        padding-left: 16px;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        vertical-align: middle;
      }

      label:before {
        content: '';
        display: inline-block;
        position: absolute;
        top: 8px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        width: 12px;
        height: 12px;
        border: 1px solid #6c6c6c;
        left: 0;
        transition: .2s;
      }
      .labelisTrue:hover + label:before {
        background: #ffffff !important;
      }
      .labelisTrue + label:after {
        content: '';
        display: inline-block;
        position: absolute;
        top: 11px;
        background-color: #383838;
        width: 6px;
        height: 6px;
        left: 3px;
      }
      span {
        line-height: 18px;
      }
    }
  }

</style>
